export default __webpack_public_path__ + "static/media/potato1.c8ccd8c2.png";